import { render, staticRenderFns } from "./addUpdateClient.vue?vue&type=template&id=bec93b4a"
import script from "./addUpdateClient.vue?vue&type=script&lang=js"
export * from "./addUpdateClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports